import React from 'react';

import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';

import { StyledFooter, StyledPrice, StyledPriceTitle, StyledProductSkeleton, StyledTitle } from './styled';

export const ProductsSkeleton: ReactFCV = () => (
  <>
    <StyledTitle />
    <GridDivider height={DIVIDER_HEIGHT} color={DIVIDER_COLOR} />
    <StyledProductSkeleton />
    <GridDivider height={DIVIDER_HEIGHT} color={DIVIDER_COLOR} />
    <StyledProductSkeleton />
    <GridDivider height={DIVIDER_HEIGHT} color={DIVIDER_COLOR} />
    <StyledProductSkeleton />
    <GridDivider height={DIVIDER_HEIGHT} color={DIVIDER_COLOR} />
    <StyledProductSkeleton />
    <GridDivider height={DIVIDER_HEIGHT} color={DIVIDER_COLOR} />
    <StyledProductSkeleton />
    <StyledFooter>
      <StyledPriceTitle />
      <StyledPrice />
    </StyledFooter>
  </>
);
